


















import Vue from 'vue';
import store from '@/store';
//@ts-ignore
import { AmplifyEventBus } from 'aws-amplify-vue';
import AuthSignOutButton from '@/components/auth/auth-sign-out-button.vue';
import CustomAuthenticator from "@/components/auth/auth-custom-authenticator.vue";
import { getModule } from "vuex-module-decorators";
import UserAuth from "@/store/auth/UserAuth";
import { Component, Watch } from "vue-property-decorator";
import ViewpointSelector from "@/components/common/viewpoint-selector.vue";

const authUserModule = getModule(UserAuth);

@Component({
  components: {
    'auth-sign-out-button': AuthSignOutButton,
    'auth-custom-authenticator': CustomAuthenticator,
  }
})
export default class AuthLogin extends Vue {

  dialog = false

  created() {
    AmplifyEventBus.$on('authState', (info: any) => {
      if (info === 'signedIn') {
        console.log("SIGNED IN STARTED")
        this.dialog = false;
      }
    });
  }

  @Watch('dialog')
  watchDialog(newVal: boolean, oldVal: boolean) {
    if (newVal) {
      this.$emit('closeDialog');
    }
  }

  get isLoggedIn(): any {
    return this.user != null
  }

  get user(): any {
    return authUserModule.user;
  }


}

